import React, { Component } from "react";

export default class Password extends Component {
  render() {
    return (
      <div className="container-fluid">
        <div className="name">
          <h4>Password</h4>
        </div>
      </div>
    );
  }
}
